export default "__VITE_ASSET__C4WVFWD7__"